import { Command } from '@/app/tracking/api';

export type EarnBadgesCommandPayload = Array<{
  id: string
  date: Date
  details: {
    title: string
    imageUri: string
    descriptionFragment: string | ''
    earnedDescriptionFragment: string | ''
  }
}>;

export const EarnBadgesCommandName = 'earn-badges' as const;

export type EarnBadgesCommand =
      Command<typeof EarnBadgesCommandName, EarnBadgesCommandPayload>;
